import { defineMessages } from "react-intl";

export const schemaMessages = defineMessages({
  selectCustomer: {
    id: "projectRegister.schemas.field.customer.required",
    defaultMessage: "Select Customer",
  },
  selectProspect: {
    id: "projectRegister.schemas.field.prospect.required",
    defaultMessage: "Select Prospect",
  },
  selectCustomerUser: {
    id: "projectRegister.schemas.field.customerUser.required",
    defaultMessage: "Select Customer User",
  },
  selectProspectUser: {
    id: "projectRegister.schemas.field.prospectUser.required",
    defaultMessage: "Select Prospect User",
  },
  selectClientType: {
    id: "projectRegister.schemas.field.clientType.required",
    defaultMessage: "Please Select Client type",
  },
  dueDateRequired: {
    id: "projectRegister.schemas.field.dueDate.required",
    defaultMessage: "Due Date is required",
  },
  wonDateError: {
    id: "projectRegister.schemas.field.wonDate.error",
    defaultMessage: "Invalid Won Date Value",
  },
  submissionDateError: {
    id: "projectRegister.schemas.field.submissionDate.error",
    defaultMessage: "Check Submission Date",
  },
  dateRequired: {
    id: "projectRegister.schemas.field.date.required",
    defaultMessage: "Date is required",
  },
  invalidBuilderNo: {
    id: "projectRegister.schemas.field.buildersNo.invalid",
    defaultMessage: "Builders No. should be a number",
  },
  quantityRequired: {
    id: "projectRegister.schemas.field.quantity.required",
    defaultMessage: "Quantity is Required",
  },
  itemNameRequired: {
    id: "projectRegister.schemas.field.itemName.required",
    defaultMessage: "Item Name is Required",
  },
  descriptionRequired: {
    id: "projectRegister.schemas.field.description.required",
    defaultMessage: "Description is Required",
  },
  priceRequired: {
    id: "projectRegister.schemas.field.price.required",
    defaultMessage: "Price is Required",
  },
  totalRequired: {
    id: "projectRegister.schemas.field.total.required",
    defaultMessage: "Total is Required",
  },
  required: {
    id: "projectRegister.schemas.validation.required",
    defaultMessage: "Required",
  },
  selectTeam: {
    id: "projectRegister.schemas.field.team.required",
    defaultMessage: "Select Team",
  },
  selectConstructionType: {
    id: "projectRegister.schemas.field.constructionType.required",
    defaultMessage: "Select Construction Type",
  },
  selectInspectors: {
    id: "projectRegister.schemas.field.inspectors.required",
    defaultMessage: "Select Inspectors",
  },
  nameRequired: {
    id: "projectRegister.schemas.field.name.required",
    defaultMessage: "Name is Required",
  },
  positionRequired: {
    id: "projectRegister.schemas.field.position.required",
    defaultMessage: "Position is Required.",
  },
  textColorRequired: {
    id: "projectRegister.schemas.field.textColor.required",
    defaultMessage: "Text Color is Required.",
  },
  textOpacityRequired: {
    id: "projectRegister.schemas.field.textOpacity.required",
    defaultMessage: "Text Opacity is Required.",
  },
  backgroundColorRequired: {
    id: "projectRegister.schemas.field.backgroundColor.required",
    defaultMessage: "Background Color is Required.",
  },
  backgroundOpacityRequired: {
    id: "projectRegister.schemas.field.backgroundOpacity.required",
    defaultMessage: "Background Opacity is required.",
  },
  selectTeamMember: {
    id: "projectRegister.schemas.field.teamMembers.required",
    defaultMessage: "Select at least one team member.",
  },
  followUpIntervalRequired: {
    id: "projectRegister.schemas.field.followUpInterval.required",
    defaultMessage: "Follow Up Interval is Required",
  },
  startingDateRequired: {
    id: "projectRegister.schemas.field.startingDate.required",
    defaultMessage: "Starting Date is Required",
  },
  statusRequired: {
    id: "projectRegister.schemas.field.status.required",
    defaultMessage: "Status is Required",
  },
  selectAtLeastOneUser: {
    id: "projectRegister.schemas.field.users.required",
    defaultMessage: "Select at least one user",
  },
  nestingDepthError: {
    id: "projectRegister.schemas.validation.nestingDepth",
    defaultMessage: "Nesting depth cannot exceed 5 levels",
  },
  totalCannotBeZero: {
    id: "projectRegister.schemas.validation.totalCannotBeZero",
    defaultMessage: "Total cannot be 0",
  },
  totalExceedMax: {
    id: "projectRegister.schemas.validation.totalExceedMax",
    defaultMessage: "Total cannot exceed maximum safe integer",
  },
  quoteVersionMax: {
    id: "projectRegister.schemas.field.quoteVersion.max",
    defaultMessage: "Quote Version cannot exceed 300 characters",
  },
  cannotExceedSubtotal: {
    id: "projectRegister.schemas.validation.cannotExceedSubtotal",
    defaultMessage: "Cannot exceed the subtotal",
  },
});

export const prMessages = defineMessages({
  projectRegister: {
    id: "projectRegister.title",
    defaultMessage: "Project Register",
  },
  activities: {
    id: "projectRegister.button.activities",
    defaultMessage: "Activities",
  },
  clientType: {
    id: "projectRegister.label.clientType",
    defaultMessage: "Client Type",
  },
  selectClientType: {
    id: "projectRegister.label.selectClientType",
    defaultMessage: "Select Client Type",
  },
  selectClientPlaceholder: {
    id: "projectRegister.placeholder.selectClient",
    defaultMessage: "Select Client: Customer/Prospect",
  },
  customer: {
    id: "projectRegister.label.customer",
    defaultMessage: "Customer",
  },
  prospect: {
    id: "projectRegister.label.prospect",
    defaultMessage: "Prospect",
  },
  clientDetails: {
    id: "projectRegister.title.clientDetails",
    defaultMessage: "Client Details",
  },
  prospectContact: {
    id: "projectRegister.label.prospectContact",
    defaultMessage: "Prospect's Contact",
  },
  customerContact: {
    id: "projectRegister.label.customerContact",
    defaultMessage: "Customer's Contact",
  },
  selectProspectContact: {
    id: "projectRegister.placeholder.selectProspectContact",
    defaultMessage: "Select Prospect's Contact",
  },
  selectCustomerContact: {
    id: "projectRegister.placeholder.selectCustomerContact",
    defaultMessage: "Select Customer's Contact",
  },
  prospectProjectNumber: {
    id: "projectRegister.label.prospectProjectNumber",
    defaultMessage: "Prospect Project Number",
  },
  customerProjectNumber: {
    id: "projectRegister.label.customerProjectNumber",
    defaultMessage: "Customer Project Number",
  },
  enterProspectProjectNumber: {
    id: "projectRegister.placeholder.enterProspectProjectNumber",
    defaultMessage: "Enter Prospect Project Number",
  },
  enterCustomerProjectNumber: {
    id: "projectRegister.placeholder.enterCustomerProjectNumber",
    defaultMessage: "Enter Customer Project Number",
  },
  ourReferenceNumber: {
    id: "projectRegister.label.ourReferenceNumber",
    defaultMessage: "Our Reference Number",
  },
  enterReferenceNumber: {
    id: "projectRegister.placeholder.enterReferenceNumber",
    defaultMessage: "Enter Reference Number",
  },
  prospectProjectName: {
    id: "projectRegister.label.prospectProjectName",
    defaultMessage: "Prospect Project Name",
  },
  projectName: {
    id: "projectRegister.label.projectName",
    defaultMessage: "Project Name",
  },
  enterProspectProjectName: {
    id: "projectRegister.placeholder.enterProspectProjectName",
    defaultMessage: "Enter Prospect Project Name",
  },
  enterProjectName: {
    id: "projectRegister.placeholder.enterProjectName",
    defaultMessage: "Enter Project Name",
  },
  dateReceived: {
    id: "projectRegister.label.dateReceived",
    defaultMessage: "Date Received",
  },
  dueDate: {
    id: "projectRegister.label.dueDate",
    defaultMessage: "Due Date",
  },
  noOfBuilders: {
    id: "projectRegister.label.noOfBuilders",
    defaultMessage: "No. of Builders",
  },
  enterNoOfBuilders: {
    id: "projectRegister.placeholder.enterNoOfBuilders",
    defaultMessage: "Enter no of builder",
  },
  reset: {
    id: "projectRegister.button.reset",
    defaultMessage: "Reset",
  },
  discardChanges: {
    id: "projectRegister.button.discardChanges",
    defaultMessage: "Discard",
  },
  saveChanges: {
    id: "projectRegister.button.saveChanges",
    defaultMessage: "Save Changes",
  },
  add: {
    id: "projectRegister.button.add",
    defaultMessage: "Add",
  },
  addTitle: {
    id: "projectRegister.title.add",
    defaultMessage: "Add Project Register",
  },
  editTitle: {
    id: "projectRegister.title.edit",
    defaultMessage: "Edit Project Register",
  },
  submissionStatus: {
    id: "projectRegister.sheet.title.submissionStatus",
    defaultMessage: "Submission Status",
  },
  invalidAddressError: {
    id: "projectRegister.error.invalidAddress",
    defaultMessage: "Please select a valid address from the dropdown list.",
  },
  selectClients: {
    id: "projectRegister.placeholder.selectClients",
    defaultMessage: "Select clients...",
  },
  searchClients: {
    id: "projectRegister.placeholder.searchClients",
    defaultMessage: "Search clients...",
  },
  selectUsers: {
    id: "projectRegister.placeholder.selectUsers",
    defaultMessage: "Select users...",
  },
  searchUsers: {
    id: "projectRegister.placeholder.searchUsers",
    defaultMessage: "Search users...",
  },
  more: {
    id: "projectRegister.label.more",
    defaultMessage: "{count} more",
  },
  projectRegisterDriveTitle: {
    id: "projectRegister.title.projectRegisterDrive",
    defaultMessage: "Project Register: {projectName}",
  },
  users: {
    id: "projectRegister.label.users",
    defaultMessage: "Users",
  },
  enterAddress: {
    id: "projectRegister.placeholder.enterAddress",
    defaultMessage: "Enter address",
  },
  projectAddressAssign: {
    id: "projectRegister.title.projectAddressAssign",
    defaultMessage: "Project Address & Assign",
  },
  areaLocation: {
    id: "projectRegister.label.areaLocation",
    defaultMessage: "Area Location",
  },
  enterAreaLocation: {
    id: "projectRegister.placeholder.enterAreaLocation",
    defaultMessage: "Enter area location",
  },
  projectAddress: {
    id: "projectRegister.label.projectAddress",
    defaultMessage: "Project Address",
  },
  assignOurTeam: {
    id: "projectRegister.label.assignOurTeam",
    defaultMessage: "Assign Our Team",
  },
  ourTeam: {
    id: "projectRegister.label.ourTeam",
    defaultMessage: "Our Team",
  },
  selectManagers: {
    id: "projectRegister.placeholder.selectManagers",
    defaultMessage: "Select managers",
  },
  projectTypeSource: {
    id: "projectRegister.title.projectTypeSource",
    defaultMessage: "Project Type,Source",
  },
  dealDescription: {
    id: "projectRegister.label.dealDescription",
    defaultMessage: "Deal Description",
  },
  selectDealDescription: {
    id: "projectRegister.placeholder.selectDealDescription",
    defaultMessage: "Select Deal Description",
  },
  estimationTypeOnly: {
    id: "projectRegister.label.estimationTypeOnly",
    defaultMessage: "Estimation Type Only",
  },
  selectEstimationType: {
    id: "projectRegister.placeholder.selectEstimationType",
    defaultMessage: "Select Estimation Type",
  },
  source: {
    id: "projectRegister.label.source",
    defaultMessage: "Source",
  },
  selectSources: {
    id: "projectRegister.placeholder.selectSources",
    defaultMessage: "Please Select Sources",
  },
  siteInspection: {
    id: "projectRegister.title.siteInspection",
    defaultMessage: "Site Inspection",
  },
  selectSiteInspection: {
    id: "projectRegister.placeholder.selectSiteInspection",
    defaultMessage: "Please Select Site Inspection",
  },
  assignSiteAttendee: {
    id: "projectRegister.label.assignSiteAttendee",
    defaultMessage: "Assign Site Attendee",
  },
  selectSiteAttendee: {
    id: "projectRegister.placeholder.selectSiteAttendee",
    defaultMessage: "Please Select Site Attendee",
  },
  inspectionOn: {
    id: "projectRegister.label.inspectionOn",
    defaultMessage: "Inspection On",
  },
});

export const prTableMessages = defineMessages({
  selectAll: {
    id: "projectRegister.table.aria.selectAll",
    defaultMessage: "Select all",
  },
  selectRow: {
    id: "projectRegister.table.aria.selectRow",
    defaultMessage: "Select row",
  },
  projectName: {
    id: "projectRegister.table.header.projectName",
    defaultMessage: "Project Name",
  },
  client: {
    id: "projectRegister.table.header.client",
    defaultMessage: "Client",
  },
  ourRefNo: {
    id: "projectRegister.table.header.ourRefNo",
    defaultMessage: "Our Ref No",
  },
  noOfBuilders: {
    id: "projectRegister.table.header.noOfBuilders",
    defaultMessage: "No. of Builders",
  },
  clientContact: {
    id: "projectRegister.table.header.clientContact",
    defaultMessage: "Client's Contact",
  },
  dateReceived: {
    id: "projectRegister.table.header.dateReceived",
    defaultMessage: "Date Received",
  },
  dueDate: {
    id: "projectRegister.table.header.dueDate",
    defaultMessage: "Due Date",
  },
  dealDescription: {
    id: "projectRegister.table.header.dealDescription",
    defaultMessage: "Deal Description",
  },
  estimationType: {
    id: "projectRegister.table.header.estimationType",
    defaultMessage: "Estimation Type",
  },
  source: {
    id: "projectRegister.table.header.source",
    defaultMessage: "Source",
  },
  assignTo: {
    id: "projectRegister.table.header.assignTo",
    defaultMessage: "Assign To",
  },
  submissionStatus: {
    id: "projectRegister.table.header.submissionStatus",
    defaultMessage: "Submission Status",
  },
  submissionDate: {
    id: "projectRegister.table.header.submissionDate",
    defaultMessage: "Submission Date",
  },
  quoteAud: {
    id: "projectRegister.table.header.quoteAud",
    defaultMessage: "Quote (AUD)",
  },
  notes: {
    id: "projectRegister.table.header.notes",
    defaultMessage: "Notes",
  },
  address: {
    id: "projectRegister.table.header.address",
    defaultMessage: "Address",
  },
  area: {
    id: "projectRegister.table.header.area",
    defaultMessage: "Area",
  },
  siteAttendee: {
    id: "projectRegister.table.header.siteAttendee",
    defaultMessage: "Site Attendee",
  },
  wonDate: {
    id: "projectRegister.table.header.wonDate",
    defaultMessage: "Won Date",
  },
  inspectionOn: {
    id: "projectRegister.table.header.inspectionOn",
    defaultMessage: "Inspection On",
  },
  followupNotes: {
    id: "projectRegister.table.header.followupNotes",
    defaultMessage: "Followup Notes",
  },
  unsuccessfulReason: {
    id: "projectRegister.table.header.unsuccessfulReason",
    defaultMessage: "Unsuccessful Reason",
  },
  archiveReason: {
    id: "projectRegister.table.header.archiveReason",
    defaultMessage: "Archive Reason",
  },
  submittedBy: {
    id: "projectRegister.table.header.submittedBy",
    defaultMessage: "Submitted By",
  },
  createdBy: {
    id: "projectRegister.table.header.createdBy",
    defaultMessage: "Created By",
  },
  wonBy: {
    id: "projectRegister.table.header.wonBy",
    defaultMessage: "Won By",
  },
  drive: {
    id: "projectRegister.table.header.drive",
    defaultMessage: "Drive",
  },
  addNewPr: {
    id: "projectRegister.table.empty.addNewPr",
    defaultMessage: "Add a new Project Register to get started",
  },
  addPrButton: {
    id: "projectRegister.table.button.addPr",
    defaultMessage: "New Project",
  },
  addPrButton2: {
    id: "projectRegister.table.button.addNewPr",
    defaultMessage: "Add New Project",
  },
  projectActivities: {
    id: "projectRegister.table.action.projectActivities",
    defaultMessage: "Project Activities",
  },
  markAsWon: {
    id: "projectRegister.table.action.markAsWon",
    defaultMessage: "Mark as Won",
  },
  archive: {
    id: "projectRegister.table.action.archive",
    defaultMessage: "Archive",
  },
  submitProject: {
    id: "projectRegister.table.action.submitProject",
    defaultMessage: "Mark as Submitted",
  },
  markAsToDo: {
    id: "projectRegister.table.action.markAsToDo",
    defaultMessage: "Mark as To Do",
  },
  editProject: {
    id: "projectRegister.table.action.editProject",
    defaultMessage: "Edit Project",
  },
  unsuccessful: {
    id: "projectRegister.table.action.unsuccessful",
    defaultMessage: "Mark as Unsuccessful",
  },
  dueDateLabel: {
    id: "projectRegister.table.filter.dueDate",
    defaultMessage: "Due Date",
  },
  submissionDateLabel: {
    id: "projectRegister.table.filter.submissionDate",
    defaultMessage: "Submission Date",
  },
  inspectionOnLabel: {
    id: "projectRegister.table.filter.inspectionOn",
    defaultMessage: "Inspection Date",
  },
});

export const prDialogMessages = defineMessages({
  archiveTitle: {
    id: "projectRegister.dialog.archive.title",
    defaultMessage: "Archive Project",
  },
  archiveSubtitle: {
    id: "projectRegister.dialog.archive.subtitle",
    defaultMessage:
      "Before archiving this project, please let us know the reason",
  },
  unsuccessfulTitle: {
    id: "projectRegister.dialog.unsuccessful.title",
    defaultMessage: "Mark Project as Unsuccessful",
  },
  unsuccessfulSubtitle: {
    id: "projectRegister.dialog.unsuccessful.subtitle",
    defaultMessage:
      "Before marking this project as unsuccessful, please let us know the reason",
  },
  submitTitle: {
    id: "projectRegister.dialog.submit.title",
    defaultMessage: "Submit Project",
  },
  submitSubtitle: {
    id: "projectRegister.dialog.submit.subtitle",
    defaultMessage: "Please enter the quote value to submit this project.",
  },
  reasonLabel: {
    id: "projectRegister.dialog.label.reason",
    defaultMessage: "Reason",
  },
  archiveButton: {
    id: "projectRegister.dialog.button.archive",
    defaultMessage: "Archive",
  },
  unsuccessfulButton: {
    id: "projectRegister.dialog.button.unsuccessful",
    defaultMessage: "Mark as Unsuccessful",
  },
  confirmButton: {
    id: "projectRegister.dialog.button.confirm",
    defaultMessage: "Yes, Confirm",
  },
  stateYourReason: {
    id: "projectRegister.dialog.placeholder.stateYourReason",
    defaultMessage: "State your reason",
  },
  enterQuoteValue: {
    id: "projectRegister.dialog.placeholder.enterQuoteValue",
    defaultMessage: "Enter quote value",
  },
  quoteLabel: {
    id: "projectRegister.dialog.label.quote",
    defaultMessage: "Quote (AUD)",
  },
});

export const prToastMessages = defineMessages({
  added: {
    id: "projectRegister.toast.added",
    defaultMessage: "New Project Register added successfully",
  },
  updated: {
    id: "projectRegister.toast.updated",
    defaultMessage: "Project Register updated successfully",
  },
  archived: {
    id: "projectRegister.toast.archived",
    defaultMessage: "Project Register archived successfully",
  },
  markedUnsuccessful: {
    id: "projectRegister.toast.markedUnsuccessful",
    defaultMessage: "Project Register marked as unsuccessful",
  },
  statusUpdated: {
    id: "projectRegister.toast.statusUpdated",
    defaultMessage: "Project Register status updated successfully",
  },
  submitted: {
    id: "projectRegister.toast.submitted",
    defaultMessage: "Project Register submitted successfully",
  },
  makeUpdate: {
    id: "projectRegister.toast.makeUpdate",
    defaultMessage: "Please make update",
  },
  noMarkSelectCustomer: {
    id: "projectRegister.toast.noMarkSelectCustomer",
    defaultMessage: "Cannot mark as done. Please select a customer.",
  },
  clientContactUpdated: {
    id: "projectRegister.toast.clientContactUpdated",
    defaultMessage: "Client contact updated successfully",
  },
  tableUpdated: {
    id: "projectRegister.toast.tableUpdated",
    defaultMessage: "Project Register Table Updated",
  },
  driveUpdated: {
    id: "projectRegister.toast.driveUpdated",
    defaultMessage: "Drive Table Updated",
  },
  notExists: {
    id: "projectRegister.toast.notExists",
    defaultMessage: "New Project Register does not exist",
  },
  somethingWrong: {
    id: "projectRegister.toast.somethingWrong",
    defaultMessage: "Something went wrong, please try again later",
  },
  optionAdded: {
    id: "projectRegister.toast.optionAdded",
    defaultMessage: "New Project Register Option Added Successfully",
  },
  documentDeleted: {
    id: "projectRegister.toast.documentDeleted",
    defaultMessage: "Project Register Document Deleted Successfully",
  },
  prOrEstimateNotExist: {
    id: "projectRegister.toast.prOrEstimateNotExist",
    defaultMessage: "Project Register or Estimate does not exist",
  },
  notesUpdated: {
    id: "projectRegister.toast.notesUpdated",
    defaultMessage: "Project Register notes updated successfully",
  },
  followNoteUpdated: {
    id: "projectRegister.toast.followNoteUpdated",
    defaultMessage: "Project Register followup notes updated successfully",
  },
  noPrFound: {
    id: "projectRegister.toast.noPrFound",
    defaultMessage: "No Project Register found",
  },
  statusAdded: {
    id: "projectRegister.toast.statusAdded",
    defaultMessage: "Project Register status added successfully",
  },
  statusDeleted: {
    id: "projectRegister.toast.statusDeleted",
    defaultMessage: "Project Register status deleted successfully",
  },
  noChange: {
    id: "projectRegister.toast.noChange",
    defaultMessage: "Please make some changes to update",
  },
  folderAdded: {
    id: "projectRegister.toast.folderAdded",
    defaultMessage: "Folder added successfully",
  },
  folderNameRequired: {
    id: "projectRegister.toast.folderNameRequired",
    defaultMessage: "Folder name is required",
  },
  folderNameMaxLength: {
    id: "projectRegister.toast.folderNameMaxLength",
    defaultMessage: "Folder name must be less than 100 characters",
  },
  estimateNotFinalized: {
    id: "projectRegister.toast.estimateNotFinalized",
    defaultMessage:
      "Cannot mark as done. Please finalize the project estimates.",
  },
});

export const prActivityMessages = defineMessages({
  title: {
    id: "projectRegister.activity.title",
    defaultMessage: "Project Register Activities",
  },
  noActivitySubtitle: {
    id: "projectRegister.activity.noActivitySubtitle",
    defaultMessage: "There is no activity available",
  },
});

export const estimationMessages = defineMessages({
  statusUpdated: {
    id: "projectRegister.estimation.toast.statusUpdated",
    defaultMessage: "Estimation status updated successfully",
  },
  statusAdded: {
    id: "projectRegister.estimation.toast.statusAdded",
    defaultMessage: "Estimation status added successfully",
  },
  statusDeleted: {
    id: "projectRegister.estimation.toast.statusDeleted",
    defaultMessage: "Estimation status deleted successfully",
  },
  submissionStatusUpdated: {
    id: "projectRegister.estimation.toast.submissionStatusUpdated",
    defaultMessage: "Estimation submission method status updated successfully",
  },
  submissionStatusAdded: {
    id: "projectRegister.estimation.toast.submissionStatusAdded",
    defaultMessage: "Estimation submission method status added successfully",
  },
  submissionStatusDeleted: {
    id: "projectRegister.estimation.toast.submissionStatusDeleted",
    defaultMessage: "Estimation submission method status deleted successfully",
  },
  optionAdded: {
    id: "projectRegister.estimation.toast.optionAdded",
    defaultMessage: "Option added successfully",
  },
  optionUpdated: {
    id: "projectRegister.estimation.toast.optionUpdated",
    defaultMessage: "Option updated successfully",
  },
  optionDeleted: {
    id: "projectRegister.estimation.toast.optionDeleted",
    defaultMessage: "Option deleted successfully",
  },
  finalQuoteSet: {
    id: "projectRegister.estimation.toast.finalQuoteSet",
    defaultMessage: "Final quote set successfully",
  },
  unFinalQuoteSet: {
    id: "projectRegister.estimation.toast.unFinalQuoteSet",
    defaultMessage: "Un-Finalized Quote successfully.",
  },
  archived: {
    id: "projectRegister.estimation.toast.archived",
    defaultMessage: "Estimate archived successfully",
  },
  activated: {
    id: "projectRegister.estimation.toast.activated",
    defaultMessage: "Estimate activated successfully",
  },
  exportInProgress: {
    id: "projectRegister.estimation.toast.exportInProgress",
    defaultMessage: "Export Estimates In Progress",
  },
  emptySubtitle: {
    id: "projectRegister.estimation.empty.subtitle",
    defaultMessage: "Add new Estimation.",
  },
  emptyBtnLabel: {
    id: "projectRegister.estimation.empty.button",
    defaultMessage: "Add Estimation",
  },
});

export const estimationActions = defineMessages({
  add: {
    id: "projectRegister.estimation.action.add",
    defaultMessage: "Add Estimation",
  },
  review: {
    id: "projectRegister.estimation.action.review",
    defaultMessage: "Review Estimation",
  },
  export: {
    id: "projectRegister.estimation.action.export",
    defaultMessage: "Export Estimates",
  },
  edit: {
    id: "projectRegister.estimation.action.edit",
    defaultMessage: "Edit Estimate",
  },
  preview: {
    id: "projectRegister.estimation.action.preview",
    defaultMessage: "Preview Estimate",
  },
});
